import { API_ROUTES } from '@/api/apiRoutes';
import { safeAxios } from '@/services/safeAxios';
import type { BillingCycle, SubscriptionType } from '@/types/shared';

interface CreateSubscriptionCheckoutSessionParams {
  billingCycle: BillingCycle;
  callbackUrl: string;
  numberOfSeats?: number;
  subscriptionType: SubscriptionType;
  workspaceId: string;
}

/** Creates a checkout session; billing cycle is selected by request data, not by a cycle-specific URL. */
export async function createSubscriptionCheckoutSession({
  billingCycle,
  callbackUrl,
  numberOfSeats = 1,
  subscriptionType,
  workspaceId,
}: CreateSubscriptionCheckoutSessionParams): Promise<string> {
  const response = await safeAxios.post<{ checkoutSessionUrl: string }>(
    API_ROUTES.workspaces.subscriptionCheckoutSession({ workspaceId }),
    {
      subscriptionType,
      billingCycle,
      callbackUrl,
      numberOfSeats,
    },
  );

  return response.data.checkoutSessionUrl;
}
